import { QntmDto } from '../dto/qntm.dto'
import { QntmModel } from '../models'

const fromDtoToQntmModelTransformer = (dto: QntmDto): QntmModel[] =>
  dto.id.map((_, index) => ({
    id: dto.id[index],
    deviceLinkId: dto.deviceLinkId[index],
    index: dto.index[index],
    deviceName: dto.deviceName[index],
    pairingState: dto.pairingState[index],
    deviceStatus: dto.deviceStatus[index],
    deviceStatusCode: dto.deviceStatusCode[index],
    lastKnownDeviceStatus: dto.lastKnownDeviceStatus[index],
    lastKnownDeviceStatusTimestamp: dto.lastKnownDeviceStatusTimestamp[index],
    type: dto.type[index],
    serial: dto.serial[index],
  }))

export default fromDtoToQntmModelTransformer
